export default "__VITE_ASSET__DQl6GlYU__"